import { render, staticRenderFns } from "./TransferCompanyRequests.vue?vue&type=template&id=5a4c8b4d&scoped=true"
import script from "./TransferCompanyRequests.vue?vue&type=script&lang=js"
export * from "./TransferCompanyRequests.vue?vue&type=script&lang=js"
import style0 from "./TransferCompanyRequests.vue?vue&type=style&index=0&id=5a4c8b4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4c8b4d",
  null
  
)

export default component.exports